import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SuccessPopupData {
  message: string;
  autoCloseMs?: number;
}

@Component({
  selector: 'hmt-success-popup',
  templateUrl: './success-popup.component.html',
  styleUrls: ['./success-popup.component.scss'],
  standalone: false,
})
export class SuccessPopupComponent {
  message: string;

  constructor(
    public dialogRef: MatDialogRef<SuccessPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SuccessPopupData
  ) {
    this.message = data?.message || 'Action completed successfully';
    const autoCloseMs = data?.autoCloseMs ?? 2500;
    if (autoCloseMs > 0) {
      setTimeout(() => this.dialogRef.close(), autoCloseMs);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
